import { stringComparator, decimalComparator, Comparator } from "@goodfill/sort";
import { PortfolioPart } from "./PortfolioDistribution";

export type PortfolioPartComparator = (a: PortfolioPart, b: PortfolioPart) => number;

export type PresentedAccountBondHoldingForSort = PortfolioPart;

export function getPortfolioDistributionLegendTableComparator(
  sortColumn: keyof PresentedAccountBondHoldingForSort,
): PortfolioPartComparator {
  const comparators: Comparator<PresentedAccountBondHoldingForSort> = {
    id: (a, b) => stringComparator(a.toString(), b.toString()),
    label: (a, b, rowA, rowB) => stringComparator(rowA.labelString, rowB.labelString),
    labelString: stringComparator,
    percentage: decimalComparator,
    absolute: decimalComparator,
  };

  const comparator: (
    a: PortfolioPart[keyof PresentedAccountBondHoldingForSort],
    b: PortfolioPart[keyof PresentedAccountBondHoldingForSort],
    rowA: PortfolioPart,
    rowB: PortfolioPart,
  ) => number =
    // rome-ignore lint/suspicious/noExplicitAny:
    comparators[sortColumn] as any;

  if (comparator === undefined) {
    throw new Error(`Comparator for ${sortColumn} not found!`);
  }

  return (a: PortfolioPart, b: PortfolioPart) => comparator(a[sortColumn], b[sortColumn], a, b);
}
